import { FetchTagsSortTypes } from '../../tagsTypes';

import {
  FETCH_TAG_NAMES_QUERY,
  FetchTagNamesQueryResponse
} from '../../queries/fetchTagNames.query';

import { usePaginatedTags } from '../usePaginatedTags';
import { TagCache } from '../../TagCache';
import { projectTagIds } from '../../tagsConstants';

const initialFilters = {
  id: { in: projectTagIds }
};

function useProjectPaginatedTags() {
  const {
    tagsData,
    tags,
    tagsError,
    tagsTotalCount,
    tagsFetched,
    tagsLoading,
    tagsIsPlaceholderData,
    tagsFilters,
    tagsSort,
    tagsPage,
    tagsLimit,
    filterTags,
    clearTagsFilters,
    sortTags,
    paginateTags,
    limitTags,
    prefetchTags
  } = usePaginatedTags<FetchTagNamesQueryResponse>({
    cacheKey: TagCache.projectTagsCacheKey(),
    query: FETCH_TAG_NAMES_QUERY,
    initialFilters,
    initialSort: [FetchTagsSortTypes.NAME_ASC]
  });

  return {
    tagsData,
    tags,
    tagsError,
    tagsTotalCount,
    tagsFetched,
    tagsLoading,
    tagsIsPlaceholderData,
    tagsFilters,
    tagsSort,
    tagsPage,
    tagsLimit,
    filterTags,
    clearTagsFilters,
    sortTags,
    paginateTags,
    limitTags,
    prefetchTags
  };
}

export default useProjectPaginatedTags;
